export default "__VITE_ASSET__DZtSzMHT__"